export default {
      id: "color_done-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "sprite.svg#color_done",
      toString: function () {
        return this.url;
      }
    }